module.exports = __webpack_public_path__ + "img/select-city.945bcea7.png";